<template>
  <div id="publishing-volume-issue-article">
    <div class="ipub-h1 mar-b-20 line-h-40 relative">
      Volume {{vol}} Issue {{issue}} Articles
      <div class="ipub-p1 right-option">
        <ipub-button type="primary"
                     @click="xmlExp">
          XML Export
        </ipub-button>
        <ipub-button type="primary"
                     @click="exp">
          Export
        </ipub-button>
        <!-- <ipub-button plain
                     type="primary"
                     @click="publish">
          Publish
        </ipub-button> -->
      </div>
    </div>
    <site-search-group class="mar-b-20"
                       v-model.trim="params.keyword"
                       placeholder="Title / DOI / Manuscript No. / Author / Keywords"
                       @search="getList()"
                       @clear="handleClear" />
    <div class="page-content">
      <ipub-table :columns="columns"
                  fixed
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:operator="{text}">
          <template v-if="text">{{text.firstName}} {{text.lastName}}</template>
          <template v-else>--</template>
        </template>
        <template v-slot:publish="{text}">
          <ipub-label size="small"
                      type="success"
                      style="width:100px"
                      cover
                      v-if="text === 'PUBLISHED'">Published</ipub-label>
          <ipub-label size="small"
                      type="danger"
                      style="width:100px"
                      cover
                      v-else-if="text === 'UNPUBLISHED'">Draft</ipub-label>
          <ipub-label size="small"
                      type="default"
                      style="width:100px"
                      cover
                      v-else-if="text === 'RETRACTION'">Retraction</ipub-label>
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip placement="bottomLeft"
                        action="click"
                        type="light"
                        class="border-right">
            <div class="hover-action-content"
                 slot="title">
              <div class="ipub-cursor-pointer">
                <a v-if="record.xmlFile"
                   target="_blank"
                   :href="`${domain}/${record.xmlFile.path}`">
                  <ipub-icon type="iconXML" />
                  Preview XML
                </a>
                <font class="disabled-icon"
                      v-else>
                  <ipub-icon type="iconXML" />
                  Preview XML
                </font>
              </div>
              <div class="ipub-cursor-pointer">
                <a v-if="record.pdfFile"
                   target="_blank"
                   :href="`${domain}/${record.pdfFile.path}`">
                  <ipub-icon type="iconPDF1" />
                  Preview PDF
                </a>
                <font class="disabled-icon"
                      v-else>
                  <ipub-icon type="iconPDF1" />
                  Preview PDF
                </font>
              </div>
            </div>
            <ipub-icon type="iconViewDetails" />
          </ipub-tooltip>
          <template>
            <ipub-tooltip v-if="!((record.status === 'RETRACTION' || (record.status === 'PUBLISHED' && record.atype && record.atype.type !== 'RETRACTION' && record.retractionCode) && record.atype && record.atype.type !== 'RETRACTION'))"
                          class="border-right">
              <div slot="title">Edit</div>
              <ipub-icon type="iconEdit"
                         @click="edit(record)" />
            </ipub-tooltip>
            <ipub-icon v-else
                       class="disabled-icon"
                       type="iconEdit" />
          </template>
          <template>
            <ipub-tooltip v-if="record.status === 'UNPUBLISHED'"
                          class="border-right">
              <div slot="title">Publish</div>
              <ipub-icon type="iconAble"
                         @click="able(record, 'PUBLISHED')" />
            </ipub-tooltip>
            <ipub-tooltip v-else-if="record.status === 'PUBLISHED' && !(record.atype && record.atype.type !== 'RETRACTION' && record.retractionCode)"
                          class="border-right">
              <div slot="title">Unpublish</div>
              <ipub-icon type="iconDisable"
                         @click="able(record, 'UNPUBLISHED')" />
            </ipub-tooltip>
            <ipub-icon v-else
                       type="iconDisable"
                       class="disabled-icon" />
          </template>
          <template>
            <ipub-tooltip v-if="record.status === 'RETRACTION'">
              <div slot="title">Cancel retraction</div>
              <ipub-icon type="iconundo"
                         @click="able(record, 'PUBLISHED')" />
            </ipub-tooltip>
            <ipub-tooltip v-else-if="record.status === 'PUBLISHED' && record.atype && record.atype.type!=='RETRACTION'">
              <div slot="title">Retractions</div>
              <ipub-icon type="icona-BacktoAuthor"
                         @click="able(record, 'RETRACTION')" />
            </ipub-tooltip>
            <ipub-icon v-else
                       type="icona-BacktoAuthor"
                       class="disabled-icon" />
          </template>
        </template>
      </ipub-table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
